export default {
    labels: {
        0: 'All',
        1: 'Maintenance & Periodic Service',
        2: 'Cooling Issue',
        3: 'Water fill',
        4: 'Platform cannot be turned on',
        5: 'No emission',
        6: 'Errors',
        7: 'SmartClinic website',
    },

    questions: [
        {
            label: 1,
            question: 'What are the parts that needs to be replaced once a year?',
            answer: 'Deionized filter, UV lamp, Deionized water and Particle filter',
        },
        {
            label: 1,
            question: 'How can i know that i filled enough water in the platform?',
            answer: 'Fill the water from the "Fill port. once the water start dripping out of the "Vent" port, it means the water level is sufficient',
        },
        {
            label: 2,
            question: 'How can I know if the cooling works properly?',
            answer: 'By using an IR Thermometer, point it on the nose of the applicator, then while platform is in Standby mode, measure the temperature every 1 minute for 6 minutes in total. \n If the result after 5 minutes is between 0 - (-2) °C, and after 6 minutes the cooling has been deactivated, then the cooling works properly.',
        },
        {
            label: 2,
            question: 'The cooling sign in the user screen shown continuously RED, what does it mean, and what should i do?',
            answer: 'Check with another applicator to verify if the sign shows up with a specific applicator. \nIf the problem is only with a specific applicator, contact your local service engineer for the applicator repair',
        },
        {
            label: 3,
            question: 'I tried to fill the water from the "Fill" port but the water failed to enter the system, what is the problem?',
            answer: 'Check that you connected the "Vent" water port properly, so that air will exit the system while water enter the water tank.',
        },

        {
            label: 4,
            question: 'The platform is connected to the power line, even though the Green switch is pressed, the platform cannot be turned on, what is the problem?',
            answer: 'Ensure the red emergency push button is not press.',
        },
        {
            label: 5,
            question: 'The applicator is connected to the platform, even though the "READY" button in the user screen is pressed, the applicator doesn\'t flashes, what may be the problem?',
            answer: '1. Ensure the foot switch is connected properly, and make sure you pressed both foot switch, and applicator trigger on the same time. \n \n 2. Check with another applicator and see if the problem appears with a specific applicator. \n\nIf the problem appears only with a specific applicator, contact your local service engineer for the applicator repair.',
        },
        {
            label: 6,
            question: 'No PIC Detect',
            answer: ' 1. Restart the system. \n 2. Replace the Handpiece. \n 3. Contact your Service provider.',
            topQuestion: true,
            img: 'service-no-pic.svg'
        },
        {
            label: 6,
            question: 'Driver Current Error/ Laser off',
            answer: ' 1. Restart the system. \n 2. Replace the Handpiece. \n 3. Contact your Service provider.',
            topQuestion: true,
            img: 'service-hardeware.svg'
        },
        {
            label: 6,
            question: 'Thermal or Level Switch Error',
            answer: ' 1. Restart the system. \n 2. Check water level. \n 3. Check room temperature is not higher than 25°C. \n 4. Check for proper air circulation, make sure the air filters surrounding the system is not blocked \n 5. Contact your Service provider.',
            topQuestion: true,
            img: 'service-flow-switch.svg'
        },
        {
            label: 6,
            question: 'Flow Switch Error',
            answer: ' 1. Restart the system. \n 2. Replace the Handpiece. \n 3. Check the water level. \n 4. Contact you Service provider.',
            topQuestion: true,
            img: 'service-thermal.svg'
        },
        {
            label: 6,
            question: 'VB=0, VB=1 error/ iButton Error',
            answer: ' 1. Restart the system. \n 2. Replace the Handpiece. \n 3. Check the integrity of pins in the Handpiece connector. \n 4. Contact your Service provider',
        },
        {
            label: 7,
            question: 'Adding and removing equipment',
            answer: 'Click on \'Equipment\' on the menu, and than select machines or handles. you will be able to add and remove equipment.',
            topQuestion: true,
            img: 'soprano-small-icon.svg'
        },
        {
            label: 7,
            question: 'Changing my personal details',
            answer: 'Click on \'Account\' on the menu. There will be an option to edit both your personal info and your clinic\'s info.',
            topQuestion: true,
            img: 'service-personal-details.svg'
        },
    ],
};
